var render = function render(){var _vm=this,_c=_vm._self._c;return (!this.$store.state.page.isMobile)?_c('PCDetail'):_c('MobileDetail')
}
var staticRenderFns = []

export { render, staticRenderFns }